"use client";
import { styled } from "@phntms/css-components";
import Image from "next/image";
import styles from "./styles.module.scss";
//import ReactPlayer from 'react-player/file';

export const HeroBannerWrapper = styled("div", {
  css: [styles.heroBanner, "hero-banner"],
  variants: {
    contain: {
      true: styles.contain,
    },
    justify: {
      center: styles.justifyCenter,
      end: styles.justifyEnd,
    },
    headerOffset: {
      true: styles.headerOffset,
    },
    darkOverlay: {
      true: styles.darkOverlay,
    },
  },
  defaultVariants: {
    justify: "center",
  },
});
export const HeroImage = styled(Image, {
  css: [styles.heroImage],
});

export const HeroVideo = styled("video", {
  css: [styles.heroVideo],
});

export const EmbedVideo = styled("div", {
  css: [styles.embedVideo],
  variants: {
    loaded: {
      true: styles.loaded,
    },
  },
});

export const Gradient = styled("div", {
  css: [styles.gradient, "hero-gradient"],
  variants: {
    size: {
      small: styles.small,
      large: styles.large,
    },
  },
  defaultVariants: {
    size: "small",
  },
});

export const CTAContainer = styled("div", {
  css: [styles.ctaContainer],
});
